import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import greaterThanIcon from "../../assets/icons/greaterthan.png";
import leftArrowIcon from "../../../public/assets/images/leftArrowIcon.png";
import SFCApprovalDetails from "./SFCApprovalDetails";
import { truncateText } from '../../utils/utilFun';
import { stpfcapprovaldetails,stpfcApprovalEmployeeWiseDetails ,resetEmployeeData,stpfcApprovalSubmit} from '../../redux/slice/stpfcdetails';
import { useDispatch, useSelector } from 'react-redux';
import Successpop from "./Successpop";
import ErrorsPopup from "../sfc/ErrorsPopup";
import { useCallback } from 'react';
import {faCircleInfo,} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Popup from "../../components/Popup";
import InitialsCircle from "../../components/InitialsCircle";
import { Tooltip } from "react-tooltip";
import Loader from '../../components/modal/Loader.jsx';

const Stpfc = () => {
  const dispatch = useDispatch();
  const { isLoading,data, employeedata} = useSelector((state) => state.stpfcdetails);
  const successMessage = useSelector((state) => state.stpfcdetails.successMessage);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
const [expandedData, setExpandedData] = useState(null);
const [selectedEmployeeData, setSelectedEmployeeData] = useState(null);
const [showPopupmsg, setShowPopupmsg] = useState(false);
const [showErrorPopup, setShowErrorPopup] = useState(false);
const [errorMessage, setErrorMessage] = useState("");
const [userDetails, setUserDetails] = useState({}); // per row status


  useEffect(() => {
    dispatch(stpfcapprovaldetails());
  }, [dispatch]);




  const handleRowClick = (employeeName, employeeId, stpfcId) => {
    if (expandedData === employeeName) {
      setExpandedData(null);
      setSelectedEmployeeId(null);
      dispatch(resetEmployeeData([]));
    } else {
      setExpandedData(employeeName);
      setSelectedEmployeeId(employeeId);
      dispatch(resetEmployeeData([]));
      if (employeeId && stpfcId) {
        dispatch(stpfcApprovalEmployeeWiseDetails({ employeeId, stpfcId }));
      }
    }
  };

  const handleApprovalAndRemarkChange = (e, id, type) => {
    const { value } = e.target;
    // Update the userDetails based on the type (status or remark)
    setUserDetails((prevDetails) => ({
      ...prevDetails,
      [id]: {
        ...prevDetails[id],
        [type]: value, // Dynamically update the specific field based on the type
      },
    }));
  };



  const handleSubmit = async (employeeId, stpfcId, slNo, levelId) => {
    const appEmpid = JSON.parse(localStorage.getItem("userData"))?.employeeId;
    const cmpID = JSON.parse(localStorage.getItem("userData"))?.companyId;

    const modifiedRecords = employeedata.filter((item) => {
      const status = userDetails[item.stpfcDetailId]?.status || "A";
      return status === "A" || status === "R";
    });

    for (const item of modifiedRecords) {
      const status = userDetails[item.stpfcDetailId]?.status;
      const remark = userDetails[item.stpfcDetailId]?.remark;

      if (status === "R" && (!remark || remark.trim() === "")) {
        setErrorMessage("Please give a valid reason for rejection");
        setShowErrorPopup(true);
        return;
      }
    }

    const Submitdata = {
      companyId: cmpID,
      employeeId: employeeId,
      stpfcId: stpfcId,
      level_id: levelId,
      appr_Empid: appEmpid,
      slNo: slNo,
      tblDetails: modifiedRecords.map((item) => {
        const status = userDetails[item.stpfcDetailId]?.status || "A";
        const remark = userDetails[item.stpfcDetailId]?.remark || "";

        return {
          stpfcId: stpfcId,
          stpfcDetailId: item.stpfcDetailId,
          status: status,
          reason: remark,
        };
      }),
    };

    await dispatch(stpfcApprovalSubmit(Submitdata));
    setShowPopupmsg(true);
    dispatch(stpfcapprovaldetails());
  };


  useEffect(() => {
    setShowPopupmsg(false);
  }, []);

  const handleOpenPopup = (employeedata) => {
    if (employeedata && Object.keys(employeedata).length > 0) {
      setSelectedEmployeeData(employeedata);
      setShowPopup(true);
    }
  };


  return (
    <div className="w-full flex flex-col bg-white lg:pt-16 lg:p-4 smAndMd:-pt-32 min-h-screen ">
      {isLoading ?(
        <Loader />
      ):(
        <>
      <div className="flex justify-center items-center w-full h-10 relative p-4 lg:p-2 mt-20 mb-2 lg:mt-0 lg:mb-0 lg:flex lg:justify-start lg:items-center smAndMd:mt-6 px-3 py-5">
        <Link to="/home" className="absolute left-4 lg:hidden">
          <img src={leftArrowIcon} alt="leftIcon" height={"10px"} width={"10px"} />
        </Link>
        <p className="text-baselg font-bold text-center lg:-ml-2 text-primary lg:text-baselg lg:font-semibold">
          <span className="smAndMd:hidden">Standard Tour Programme Fare Chart </span><span className="lg:hidden">STPFC </span>Approval
        </p>
      </div>
      <div className="w-full h-[0.5px] bg-line-color smAndMd:hidden"></div>
      <p className="text-baseMd smAndMd:text-center mt-2 -mb-3 text-left text-primary-black lg:text-baseMd ">
        {expandedData === null ? ' STPFC MR Approval Details' : 'Standard Fare Chart Approval'}
      </p>

  <div className="mt-7">
    {data && data.length > 0 ? (
      <>
        {/* Table Header */}
        <div className="grid grid-cols-5 bg-gray-200 flex-wrap rounded-t-md p-4 font-semibold text-baseSm text-center text-gray-700 smAndMd:hidden">
          <div className="col-span-1 pr-10">Employee Name</div>
          <div className="col-span-1 border-l border-gray-400 pr-10">Employee Code</div>
          <div className="col-span-1 border-l border-gray-400 pr-10">Territory</div>
          <div className="col-span-1 border-l border-gray-400 pr-10">Designation</div>
          <div className="col-span-1 border-l border-gray-400 pr-10">Status</div>
        </div>

        {/* Table Body */}
        <div className="bg-white flex-wrap rounded-b-md border border-t-2 border-gray-300 smAndMd:hidden">
          {data.map((dataItem, index) => (
            <div key={index}>
              <div
                className="grid grid-cols-5 text-baseSm items-center text-center  font-medium  text-[#514D4C] p-2"

              >
              <div className="flex items-center space-x-4 ">
                <span data-tooltip-id="expand"
                  data-tooltip-content={expandedData === dataItem.employeeName ? "" : "Expand"}>
                <img
                  src={greaterThanIcon}
                  className={`w-8 h-8 cursor-pointer transform transition-transform ${
                    expandedData === dataItem.employeeName ? "rotate-90" : ""
                  }`}
                  alt="toggle"
                  onClick={() =>
                    handleRowClick(dataItem.employeeName, dataItem.employeeId, dataItem.stpfcId)
                  }

                />
                <Tooltip id='expand' className="!text-xs !font-normal !z-50"/>
                </span>
                <div className="pr-10 font-medium">{dataItem.employeeName}</div>
              </div>
              <div className="col-span-1 pr-10 ">{dataItem.employeeCode}</div>
              <div className="col-span-1 pr-10">{dataItem.territory}</div>
              <div className="col-span-1 pr-10">{dataItem.designation}</div>
              <div className="col-span-1 ">{dataItem.status}</div>
            </div>
            {index < data.length - 1 && (<hr className="border-t border-gray-300 mx-4" />)}
            {/* Expanded Details */}
            {expandedData === dataItem.employeeName && selectedEmployeeId === dataItem.employeeId &&
              Array.isArray(employeedata)&& employeedata.length > 0 && (
                <div className="bg-gray-100 p-3">
                  <div className="grid grid-cols-10 text-baseSm text-center font-semibold text-gray-700">
                    <div className="col-span-1 pr-6">From City</div>
                    <div className="col-span-1 pr-15">To City</div>
                    <div className="col-span-1 pr-15">Category</div>
                    <div className="col-span-2 pr-10">Daily Allowance</div>
                    <div className="col-span-1 pr-10">Fare</div>
                    <div className="col-span-1 pr-10">Total</div>
                    <div className="col-span-1 pr-10">Status</div>
                    <div className="col-span-2 pr-10">Reason</div>
                  </div>
                  <div className="w-full h-[0.5px] mt-2 mb-2 bg-line-color"></div>
                  {employeedata.map((item) => (
                    <div key={item?.stpfcDetailId}>
                      <div className="grid grid-cols-10 py-2 text-baseSm text-center font-medium rounded-t-md text-[#514D4C] ">
                        <div
                          className="col-span-1 flex text-primary font-semibold  cursor-pointer "

                        >
                        <span className="pr-1">{truncateText(item.fromCity,7)}</span>
                        <span  data-tooltip-id="popup" data-tooltip-content='View more details'
                        onClick={() => handleOpenPopup(item)}>
                          <Popup color="#A04D95"  />
                          </span>
                          <Tooltip id='popup' className="!text-xs !font-normal"/>
                        </div>
                        <div className="col-span-1 pr-15">{truncateText(item.fromCity,9)}</div>
                        <div className="col-span-1 pr-15">{item.category}</div>
                        <div className="col-span-2 -ml-5 "><span>₹ </span> {item.allowance}</div>
                        <div className="col-span-1 pr-6"><span>₹ </span>{item.oneWayFare}</div>
                        <div className="col-span-1 pr-10"><span>₹ </span>{item.total}</div>
                    <div className="col-span-1 pr-10 flex flex-col items-start">
                      <label className="flex items-center space-x-1">
                        <input
                        className="accent-primary"
                          type="radio"
                          value="A"
                          checked={userDetails[item.stpfcDetailId]?.status === "A" || !userDetails[item.stpfcDetailId]?.status}
                          onChange={(e) => handleApprovalAndRemarkChange(e, item.stpfcDetailId, "status")}
                          defaultChecked
                        />
                        <span>Approve</span>
                      </label>
                      <label className="flex items-center space-x-1 mt-2">
                        <input
                        className="accent-primary"
                          type="radio"
                          value="R"
                          checked={userDetails[item.stpfcDetailId]?.status === "R"}
                          onChange={(e) => handleApprovalAndRemarkChange(e, item.stpfcDetailId, "status")}
                        />
                        <span>Reject</span>
                      </label>
                    </div>
                  <div className="col-span-2 pl-2">
                    <textarea
                      className="border border-gray-300 rounded-md p-2 w-full focus:outline-none focus:ring-1 focus:ring-[#A15CA4]"
                      name="remark"
                      value={userDetails[item.stpfcDetailId]?.remark || ""}
                      onChange={(e) => handleApprovalAndRemarkChange(e, item.stpfcDetailId, "remark")}
                    ></textarea>
                  </div>
                </div>
              </div>
            ))}
            <div className="flex justify-end text-[18px] ">
                <button
                  className="smAndMd:w-full bg-primary text-white rounded-full p-2 px-10 "
                  onClick={() =>
                    handleSubmit(
                      dataItem.employeeId,
                      dataItem.stpfcId,
                      dataItem.slNo,
                      dataItem.levelId
                    )
                  }
                >
                  Submit
                </button>
              </div>
                </div>
              )}
          </div>
        ))}
      </div>
    </>
    ):(
      <div className="text-primary flex justify-center items-center font-medium h-full mt-44 ">
        No Data Found
      </div>
    )
  }
</div>
</>
)}


{/* Mobile View */}
  <div className="lg:hidden">
    {Array.isArray(data) && data.length > 0 && (
      <>
      {data.map((dataItem, index) => (
        <div
          key={index}
          className="bg-white flex-wrap rounded-b-none border text-center border-t-1 border-gray-300"
        >
      <div className="p-3 rounded-md hover:shadow-sm cursor-pointer border"
        >
        <div className="flex items-center">
            <div className="">
            <InitialsCircle fullName={dataItem.employeeName} />
            </div>
          <div className="ml-4 flex-1">
            <div className="flex justify-between items-center">
              <p className="text-baselg font-semibold text-[#000000]">
                {truncateText(dataItem.employeeName,12)}
              </p>
              <p className="text-[#514D4C] text-baseSm ">
                {truncateText(dataItem.status)}
              </p>
            </div>

            <div className="flex justify-between text-sm text-[#514D4C] mt-1 font-medium">
              <p>{dataItem.employeeCode}</p>
              <p>{dataItem.designation}</p>

            </div>

            <div className="flex justify-between text-sm text-[#514D4C] mt-1 font-medium">
              <p>
              {dataItem.territory}
              </p>
              <img
                src={greaterThanIcon}
                className={`-mt-2 w-9 h-9  transform transition-transform ${ expandedData === dataItem.employeeName ? "rotate-90" : ""}`}
                alt="toggle"
                onClick={() => handleRowClick(dataItem.employeeName, dataItem.employeeId, dataItem.stpfcId)}
              />
            </div>
          </div>
        </div>
      </div>


          {expandedData === dataItem.employeeName &&
            Array.isArray(employeedata) &&
            employeedata.length > 0 && (
              <div className="border border-gray-200 rounded-sm pb-2 text-[14px] items-center text-gray-700">
                <p className="font-semibold text-left bg-[#F7F0FF]  pl-4 pt-2 pb-2">
                  Approval Details
                </p>
                {/* Expanded Row Data  */}
                {employeedata.map((item) => (
                  <div key={item?.stpfcDetailId}>
                    <div className="grid grid-cols-2 gap-x-10 gap-y-3 my-1 pl-4 pr-4 text-[12px] pt-2 text-[#514D4C]">
                      <p className="font-medium  text-left">From City </p>
                      <p className=" text-right">{item.fromCity}</p>
                    </div>
                    <div className="grid grid-cols-2 gap-x-10 gap-y-3 my-1 pl-4 pr-4 text-[12px] text-[#514D4C]">
                      <p className="font-medium text-left">To City </p>
                      <p className="text-right">{item.toCity}</p>
                    </div>
                    <div className="grid grid-cols-2 gap-x-10 gap-y-3 my-1 pl-4 pr-4 text-[12px] text-[#514D4C]">
                        <p className="font-medium text-left">Territory </p>
                        <p className="text-right">{item.territory}</p>
                      </div>
                    <div className="grid grid-cols-2 gap-x-10 gap-y-3 my-1 pl-4 pr-4 text-[12px] text-[#514D4C]">
                      <p className="font-medium text-left">Category </p>
                      <p className="text-right">{item.category}</p>
                    </div>
                    <div className="grid grid-cols-2 gap-x-10 gap-y-3 my-1 pl-4 pr-4 text-[12px] text-[#514D4C]">
                      <p className="font-medium text-left">Travel Mode </p>
                      <p className="text-right">{item.transportType}</p>
                    </div>
                    <div className="grid grid-cols-2 gap-x-10 gap-y-3 my-1 pl-4 pr-4 text-[12px] text-[#514D4C]">
                        <p className="font-medium text-left">No. of Chemits </p>
                        <p className="text-right">{item.noOfChemists}</p>
                      </div>
                      <div className="grid grid-cols-2 gap-x-10 gap-y-3 my-1 pl-4 pr-4 text-[12px] text-[#514D4C]">
                        <p className="font-medium text-left">No. of Doctors </p>
                        <p className="text-right">{item.noOfDoctors}</p>
                      </div>
                      <div className="grid grid-cols-2 gap-x-10 gap-y-3 my-1 pl-4 pr-4 text-[12px]  text-[#514D4C]">
                      <p className="font-medium text-left">Allowance </p>
                      <p className="text-right"><span>₹ </span>{item.allowance}</p>
                    </div>
                    <div className="grid grid-cols-2 gap-x-10 gap-y-3 my-1 pl-4 pr-4 text-[12px] text-[#514D4C]">
                        <p className="font-medium text-left">One-Way Distance </p>
                        <p className="text-right">{item.oneWayDistance} <span>KM </span></p>
                      </div>
                      <div className="grid grid-cols-2 gap-x-10 gap-y-3 my-1 pl-4 pr-4 text-[12px] text-[#514D4C]">
                        <p className="font-medium text-left">Two-way Distance </p>
                        <p className="text-right">{item.twoWayDistance} <span>KM </span></p>
                      </div>
                      <div className="grid grid-cols-2 gap-x-10 gap-y-3 my-1 pl-4 pr-4 text-[12px] text-[#514D4C]">
                        <p className="font-medium text-left">One-Way Fare </p>
                        <p className="text-right"><span>₹ </span>{item.oneWayFare}</p>
                      </div>
                      <div className="grid grid-cols-2 gap-x-10 gap-y-3 my-1 pl-4 pr-4 text-[12px] text-[#514D4C]">
                        <p className="font-medium text-left">Two-Way Fare </p>
                        <p className="text-right"><span>₹ </span>{item.twoWayFare}</p>
                      </div>
                      {index < expandedData.length - 1 && (<hr className="border-t border-gray-300 mx-4 my-2 z-50" />)}
                      <div className="grid grid-cols-2 gap-x-10 gap-y-3 my-1 pl-4 pr-4 text-[14px] text-black">
                        <p className="font-semibold text-left">Total </p>
                        <p className="font-semibold text-right"><span>₹ </span>{item.total}</p>
                      </div>
                      {index < expandedData.length - 1 && (<hr className="border-t border-gray-300 mx-4 my-2" />)}

                    <div className="flex items-start justify-between text-[12px] my-1 pl-4 pr-4 text-[#514D4C] pb-1">
                      <p className="font-medium ">Status</p>
                      <div className="flex  gap-4 mt-1 ">
                        <label className="flex items-center space-x-1">
                          <input
                          className="accent-primary"
                            type="radio"
                            value="A"
                            checked={userDetails[item.stpfcDetailId]?.status === "A" || !userDetails[item.stpfcDetailId]?.status}
                            onChange={(e) =>
                              handleApprovalAndRemarkChange(e, item.stpfcDetailId, "status")
                            }
                            defaultChecked
                          />
                          <span className="text-[#514D4C]">Approve</span>
                        </label>

                        <label className="flex items-center space-x-1">
                          <input
                          className="accent-primary"
                            type="radio"
                            value="R"
                            checked={userDetails[item.stpfcDetailId]?.status === "R"}
                            onChange={(e) =>
                              handleApprovalAndRemarkChange(e, item.stpfcDetailId, "status")
                            }
                          />
                          <span className="text-[#514D4C]">Reject</span>
                        </label>
                      </div>
                    </div>

                    <div className="grid grid-cols-2 gap-x-5 gap-y-3 my-1 pl-4 pr-4 text-[12px] pb-2 text-[#514D4C]">
                      <p className="font-medium text-left">Reason</p>
                      <textarea
                        className="border border-gray-300 rounded-md p-1 text-xs h-10 w-full focus:outline-none focus:ring-1 focus:ring-[#A15CA4]"
                        name="remark"
                        value={userDetails[item.stpfcDetailId]?.remark || ""}
                        onChange={(e) => handleApprovalAndRemarkChange(e, item.stpfcDetailId, "remark")}
                      />
                    </div>
                    <div className="border-t border-gray-300 my-2"></div>
                  </div>
                ))}
                <div className="items-center text-[16px]  smAndMd:shadow-top">

                  <button
                    className="bg-primary text-white rounded-full p-2  px-36"
                    onClick={() =>
                      handleSubmit(
                        dataItem.employeeId,
                        dataItem.stpfcId,
                        dataItem.slNo,
                        dataItem.levelId
                      )
                    }
                  >
                    Submit
                  </button>
                </div>
              </div>
            )}
        </div>
      ))}
    </>

  )}
</div>


      {/* Error Popup */}
      {showErrorPopup && (
        <ErrorsPopup
          show={showErrorPopup}
          message={errorMessage}
          onClose={() => setShowErrorPopup(false)}
        />
      )}

        {/* Success Popup */}
      {showPopupmsg && (
        <Successpop
        displayText={successMessage}
          onClose={() => setShowPopupmsg(false)}
        />
      )}

        {/* Popup Component */}
        {showPopup && (
          <SFCApprovalDetails onClose={() => setShowPopup(false)} employeedata={selectedEmployeeData} />
        )}
</div>

    );
  }

export default Stpfc;
